import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface TargetItem {
  id: number | null;
  salesPersonId: number;
  salesPersonName: string;
  email: string;
  target: number | null;
  hasTarget: boolean;
  countryId?: number;
  countryName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TargetService {
  private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/target`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  /**
   * Get targets by country and year
   */
  public getTargetsByCountryAndYear(
    countryId: number | undefined,
    year: number,
  ): Observable<{ result: TargetItem[] }> {
    let queryParams = new HttpParams();
    if (countryId) {
      queryParams = queryParams.set('countryId', countryId.toString());
    }
    queryParams = queryParams.set('year', year.toString());
    return this.http
      .get<{
        result: TargetItem[];
      }>(`${this.URL_PATH}/getTargetsByCountryAndYear`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Batch upsert targets
   */
  public batchUpsert(
    year: number,
    targets: Array<{
      countryId?: number;
      salesPersonId: number;
      target: number;
    }>,
  ): Observable<{ message: string; updated: number; created: number }> {
    return this.http
      .post<{ message: string; updated: number; created: number }>(
        `${this.URL_PATH}/batchUpsert`,
        {
          year,
          targets,
        },
      )
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Export targets
   */
  public exportTargets(
    countryId: number | undefined,
    year: number,
  ): Observable<Blob> {
    let queryParams = new HttpParams();
    if (countryId) {
      queryParams = queryParams.set('countryId', countryId.toString());
    }
    queryParams = queryParams.set('year', year.toString());
    return this.http.get(`${this.URL_PATH}/downloadExcelReport`, {
      params: queryParams,
      responseType: 'blob',
    });
  }
}
